var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-box"},[_c('base-header'),_vm._v(" "),(_vm.type == 1)?_c('h1',[_vm._v("加载中…")]):_c('base-button',{staticClass:"auth-btn",attrs:{"name":"微信授权一键登录"},on:{"click":function($event){return _vm.get_auth()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-914a22b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/auth_page.vue
// module id = null
// module chunks = 